













































import { Vue, Component } from "@/shared/vuepack";
import * as ucb from "@/shared/ucbUrls";
import { AppBrowserTarget, isMobileApp, openUrl } from "@/shared/mobileHelper";

@Component({
  components: {
  }
})
export default class UcbForms extends Vue {
  UcbUrls = ucb;

  clickLink (event) {
    if (isMobileApp()) {
      openUrl(event.currentTarget.href, AppBrowserTarget.system);
    } else window.open(event.currentTarget.href, event.currentTarget.target);
  }
}
